import script from "./CZoneTournamentItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./CZoneTournamentItem.vue?vue&type=script&setup=true&lang=ts"

import "./CZoneTournamentItem.vue?vue&type=style&index=0&id=0eec47b1&lang=less"

const __exports__ = script;

export default __exports__